import { QueryAPI } from "../api";

export const useReport = () => {
	const sPSalesPerState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/SPSalesPerState", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const ePSalesPerState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/EPSalesPerState", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const dCSalesPerState = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/DCSalesPerState", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportDCProductCountSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportDCProductCountSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportEPProductCountSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportEPProductCountSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportSPProductCountSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportSPProductCountSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const statisticalReportProductCommissionSales = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/StatisticalReportProductCommissionSales", parameters: parameters, type: "GET" });
		return response ? response : null;
	};
	const swSalesPerState = async () => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/SWSalesPerState", type: "GET" });
		return response ? response : null;
	};
	const coSalesPerState = async () => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/COSalesPerState", type: "GET" });
		return response ? response : null;
	};
	const querySPPurchaseDealerByCertNo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QuerySPPurchaseDealerByCertNo", parameters: parameters });
		return response ? response : null;
	};
	const querySPPurchaseDealerByMSISDN = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QuerySPPurchaseDealerByMSISDN", parameters: parameters });
		return response ? response : null;
	};
	const queryDealerGrowthDaily = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QueryDealerGrowthDaily", parameters: parameters, silent: true });
		return response ? response : null;
	};
	const queryCOPurchaseDocumentInfo = async (parameters) => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/QueryCOPurchaseDocumentInfo", parameters: parameters });
		return response ? response : null;
	};
	// counts of the logged-in dealer's requests waiting for document upload (SP / CO / SW + server TotalCount)
	const pendingDocumentUploadCounts = async () => {
		let response = null;
		response = await QueryAPI({ url: "/dealer/Reports/PendingDocumentUploadCounts", type: "GET", silent: true });
		const r = response && !response.HasError ? response.Result : null;
		if (!r) return null;
		// doc says PascalCase, but accept camelCase too in case the API serializer differs
		return {
			SPPurchaseCount: r.SPPurchaseCount ?? r.spPurchaseCount ?? 0,
			COPurchaseCount: r.COPurchaseCount ?? r.coPurchaseCount ?? 0,
			SWPurchaseCount: r.SWPurchaseCount ?? r.swPurchaseCount ?? 0,
			TotalCount: r.TotalCount ?? r.totalCount ?? 0,
		};
	};
	return {
		pendingDocumentUploadCounts,
		queryCOPurchaseDocumentInfo,
		queryDealerGrowthDaily,
		swSalesPerState,
		coSalesPerState,
		sPSalesPerState,
		ePSalesPerState,
		dCSalesPerState,
		statisticalReportDCProductCountSales,
		statisticalReportEPProductCountSales,
		statisticalReportSPProductCountSales,
		statisticalReportProductCommissionSales,
		querySPPurchaseDealerByCertNo,
		querySPPurchaseDealerByMSISDN,
	};
};
